/* import __COLOCATED_TEMPLATE__ from './reviewable-scores.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
